import { render, staticRenderFns } from "./EmptyWidget.vue?vue&type=template&id=326e88c8&scoped=true"
import script from "./EmptyWidget.vue?vue&type=script&lang=js"
export * from "./EmptyWidget.vue?vue&type=script&lang=js"
import style0 from "./EmptyWidget.vue?vue&type=style&index=0&id=326e88c8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "326e88c8",
  null
  
)

export default component.exports